import React, { useState, useEffect } from "react";
import { message as antdMessage, Form, message, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import {
  fetchAnnouncements,
  addAnnouncement,
  editAnnouncement,
  deleteAnnouncement,
} from "Services/AdminServices/AnnouncementService";

const useAnnouncementHooks = () => {
  const [form] = Form.useForm();
  const [announcements, setAnnouncements] = useState([]);
  const [isAdding, setIsAdding] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    loadAnnouncements();
  }, []);

  const loadAnnouncements = async () => {
    setLoading(true);
    try {
      const data = await fetchAnnouncements();
      setAnnouncements(data);
    } catch (error) {
      antdMessage.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAddAnnouncement = () => {
    setIsAdding(true);
    setEditMode(false);
    setSelectedAnnouncement(null);
    form.resetFields();
  };

  const handleCancel = () => {
    setIsAdding(false);
    setEditMode(false);
    setSelectedAnnouncement(null);
    form.resetFields();
  };

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      const values = await form.validateFields();
console.log("VALUES:", values);
      await addAnnouncement(values);
      antdMessage.success("Announcement Created Successfully!");
      setIsAdding(false);
      loadAnnouncements();
    } catch (error) {
      antdMessage.error(error.message);
    } finally {
      setSubmitting(false);
    }
  };

const handleEditAnnouncement = async () => {
  try {
    const values = await form.validateFields();

    const payload = {
      announcementId: selectedAnnouncement.id, // required
      title: values.title,
      message: values.message, // make sure this matches Form.Item name
    };

    await editAnnouncement(payload);
    antdMessage.success("Announcement Updated Successfully!");
    setEditMode(false);
    setSelectedAnnouncement(null);
    form.resetFields();
    loadAnnouncements();
  } catch (error) {
    antdMessage.error(error.message);
  }
};

  const handleMenuClick = async (action, ann) => {
    switch (action) {
      case "view":
        navigate(`/announcement-detail/${ann.id}`, { state: { announcement: ann } });
        break;
      case "edit":
      setEditMode(true);
      setSelectedAnnouncement(ann);
      form.setFieldsValue({
        title: ann.title, // must match Form.Item name
        message: ann.message,
      });
      break;
      case "delete":
        Modal.confirm({
          title: "Confirm Delete",
          content: "Are you sure you want to delete this announcement?",
          okText: "Yes, Delete",
          okType: "danger",
          cancelText: "Cancel",
          onOk: async () => {
            try {
              await deleteAnnouncement(ann.id);
              antdMessage.success("Announcement deleted successfully");
              loadAnnouncements();
            } catch (error) {
              antdMessage.error(error.message);
            }
          },
        });
        break;
      default:
        break;
    }
  };

  const menu = (ann) => ({
    items: [
      {
        key: "view",
        label: "View Announcement",
        onClick: () => handleMenuClick("view", ann),
      },
      {
        key: "edit",
        label: "Edit",
        onClick: () => handleMenuClick("edit", ann),
      },
      {
        key: "delete",
        label: "Delete",
        onClick: () => handleMenuClick("delete", ann),
      },
    ],
  });

  const truncateText = (text, maxLength) => {
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
  };

  return {
    submitting,
    isAdding,
    handleCancel,
    editMode,
    loading,
    announcements,
    menu,
    handleEditAnnouncement,
    handleSubmit,
    handleAddAnnouncement,
    truncateText,
    form
  };
};

export default useAnnouncementHooks;
